"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ColorPaletteItem_1 = tslib_1.__importDefault(require("./ColorPaletteItem"));
var MAX_SMALL_PALETTE_SIZE = 20;
var ColorPalette = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPalette, _super);
    function ColorPalette() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onColorSelected = function (color) {
            _this.props.onColorSelected(color);
        };
        return _this;
    }
    ColorPalette.prototype.render = function () {
        return (react_1.default.createElement("div", { "aria-label": "Color palette", className: this.getClassNames() }, this.renderItems()));
    };
    ColorPalette.prototype.getClassNames = function () {
        var isColorPaletteLarge = this.isColorPaletteLarge();
        return classnames_1.default({
            "gd-color-drop-down-list-large": isColorPaletteLarge,
            "gd-color-drop-down-list": !isColorPaletteLarge,
        }, "s-color-drop-down-list");
    };
    ColorPalette.prototype.renderItems = function () {
        var _this = this;
        return this.props.colorPalette.map(function (item) {
            return (react_1.default.createElement(ColorPaletteItem_1.default, { selected: _this.isItemSelected(item.guid), key: item.guid, paletteItem: item, onColorSelected: _this.onColorSelected }));
        });
    };
    ColorPalette.prototype.isColorPaletteLarge = function () {
        return this.props.colorPalette.length > MAX_SMALL_PALETTE_SIZE;
    };
    ColorPalette.prototype.isItemSelected = function (guid) {
        return this.props.selectedColorGuid === guid;
    };
    return ColorPalette;
}(react_1.default.PureComponent));
exports.default = ColorPalette;
//# sourceMappingURL=ColorPalette.js.map